import request from 'utils/request'
import { MCAXS591InitRequest } from 'types/MCAXS591/MCAXS591InitRequest'

export const getMCAXS591InitRequest = (data: MCAXS591InitRequest) =>
  request({
    url: '/MCAXS591/init',
    method: 'post',
    data: data,
  })
